<template>
  <div>
    <v-card-text>
      <v-card-title class="px-0">
        <v-btn @click="openDialog" color="primary ml-0"> Add Link Permission </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          label="Search"
          hide-details
          outline
          :height="1"
        ></v-text-field>
      </v-card-title>
      <ag-grid-vue
        style="width: 100%; padding: 5px"
        class="ag-theme-balham mt-2 mb-4"
        domLayout="autoHeight"
        :columnDefs="columnDefs"
        :rowData="rows"
        :defaultColDef="defaultColDef"
        @grid-ready="onGridReady"
        @rowSelected="getSelectedRows()"
        rowSelection="single"
        :frameworkComponents="frameworkComponents"
        :paginationPageSize="10"
        pagination
      ></ag-grid-vue>
      <!-- 
      :defaultColDef="defaultColDef"
      :frameworkComponents="frameworkComponents"
      @first-data-rendered="onFirstDataRendered" -->
    </v-card-text>
    <v-dialog v-model="dialog" width="600" persistent>
      <PermissionDialog
        :menuPermission="filteredVal"
        :selected="selected"
        :isEdit="isEdit"
        @save="save"
        @onDelete="onDelete"
        @close="close"
      />
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { mapMenuPermissionsFields } from '@/store/modules/menuPermissions'
import { AgGridVue } from 'ag-grid-vue'
import PermissionLevel from './user-permissions/permissions-select.vue'
import PermissionDialog from './menuPermission-dialog.vue'
import MenuPermission from '@/models/MenuPermission'
const { mapActions: mapMenuPermissionsActions } = createNamespacedHelpers(
  'menuPermissions'
)

export default {
  name: 'Permission',
  components: {
    AgGridVue,
    PermissionLevel,
    PermissionDialog
  },
  data: function () {
    return {
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      frameworkComponents: null,
      height: '100%',
      width: '100%',
      search: '',
      panel: [true, true, true],
      dialog: false,
      selected: {},
      isEdit: false,
      menuPermission: new MenuPermission()
    }
  },
  computed: {
    ...mapMenuPermissionsFields(['message', 'rows', 'permissionSet']),
    filteredVal() {
      let vm = this

      if (!vm.menuPermission) return

      if (!vm.isEdit) vm.menuPermission = vm.permissionSet

      return vm.menuPermission
    }
  },
  beforeMount() {
    let vm = this
    vm.gridOptions = {}
    vm.columnDefs = [
      {
        headerName: 'Link Title',
        field: 'title',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Group Link',
        field: 'menuItem',
        sortable: true,
        filter: true,
        maxWidth: 200
      },
      {
        headerName: 'Route',
        field: 'route',
        sortable: true,
        filter: true,
        maxWidth: 200
      },

      {
        headerName: 'AuthGroups',
        field: 'authGroups',
        valueGetter: (params) => {
          return JSON.stringify(params.data.authGroups)
        }
      }
    ]
    vm.frameworkComponents = {
      permissionLevel: PermissionLevel
    }
    vm.defaultColDef = {
      autoHeight: true
    }

    vm.getPermissionGroups()
    vm.getMenuPermissions()
  },
  methods: {
    ...mapMenuPermissionsActions([
      'getMenuPermissions',
      'getPermissionGroups',
      'saveMenuPermissions',
      'deleteMenuPermission'
    ]),
    onGridReady(params) {
      let vm = this
      vm.gridApi = params.api
      vm.gridApi.sizeColumnsToFit()
    },
    openDialog() {
      let vm = this
      vm.dialog = true
    },
    close(data) {
      let vm = this
      vm.isEdit = false
      vm.dialog = data
    },
    save(item) {
      let vm = this
      if (item) {
        vm.saveMenuPermissions(item).then((data) => {
          if (data.statusCode == 200) {
            vm.resetMenuPermission()
          }
        })
      }
    },
    onDelete(item) {
      let vm = this
      if (item) {
        vm.deleteMenuPermission(item).then((data) => {
          if (data.statusCode == 200) {
            vm.resetMenuPermission()
          }
        })
      }
    },
    getSelectedRows() {
      let vm = this
      const selectedData = vm.gridApi.getSelectedRows()
      vm.menuPermission = selectedData[0]
      vm.isEdit = true
      vm.dialog = true
    },
    resetMenuPermission() {
      let vm = this
      vm.isEdit = false
      vm.dialog = false
      vm.menuPermission = vm.permissionSet
    },
    getGrandPermission(params, val) {
      if (params.data.permissions.length) {
        var data = params.data.permissions.filter(
          (x) => x.group.groupName.toLowerCase() == val
        )
        return data[0].grant
      }
      return false
    }
  },
  watch: {
    search(val) {
      this.gridApi.setQuickFilter(val)
    }
  }
}
</script>

<style></style>
